// Capture UTM + referral + campaign-location params from the QR-code URL.
// Persisted to sessionStorage so it survives in-page navigation.

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export function captureTracking() {
  const params = new URLSearchParams(window.location.search);
  const tracking = {};

  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) tracking[k] = v;
  });

  // Flyer / QR campaign location can arrive as ?loc= or ?campaign_location=
  const loc =
    params.get("campaign_location") ||
    params.get("loc") ||
    params.get("flyer");
  if (loc) tracking.campaign_location = loc;

  tracking.referral_source = document.referrer || "direct";
  tracking.landing_path = window.location.pathname + window.location.search;

  try {
    const existing = JSON.parse(sessionStorage.getItem("raahi_tracking") || "{}");
    const merged = { ...existing, ...tracking };
    sessionStorage.setItem("raahi_tracking", JSON.stringify(merged));
    return merged;
  } catch {
    return tracking;
  }
}

export function getTracking() {
  try {
    return JSON.parse(sessionStorage.getItem("raahi_tracking") || "{}");
  } catch {
    return {};
  }
}
